// Invite route - handles /invite/:token URLs
// For users without a clientId, the OnboardingGate in __root.tsx handles this automatically
// by detecting the /invite/:token URL pattern and showing the invite redemption UI.
// This route file ensures TanStack Router doesn't 404 on the path.

import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';

export const Route = createFileRoute('/invite/$token')({
  component: InvitePageComponent,
});

// This component only renders for users who ALREADY have a clientId
// (since users without one are intercepted by OnboardingGate).
function InvitePageComponent() {
  const { token } = Route.useParams();

  useQuery({
    queryKey: ['invite-validate', token],
    queryFn: () => api.onboarding.validateInvite(token),
  });

  return (
    <div className="min-h-screen bg-[#0B0E14] text-slate-200 flex items-center justify-center p-8">
      <div className="max-w-md w-full">
        <div className="bg-[#151921] rounded-xl border border-slate-800 p-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-emerald-500/10 flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-8 h-8 text-emerald-400" />
          </div>

          <h2 className="text-xl font-bold mb-2">Already a Member</h2>
          <p className="text-slate-400 text-sm mb-6">
            You are already assigned to an organization. This invite link does not apply to your account.
          </p>

          <Link
            to="/"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-500/10 text-cyan-400 hover:bg-cyan-500/20 transition-colors text-sm font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
